import { useCallback } from 'react';
import { CampaignCarousel } from '~/components/campaign-carousel';
import { ClickPosition } from '~/utils/click-position';
import { ModuleType } from '~/utils/module-type';
import { useParams } from '@remix-run/react';
import { useViewTracking } from '~/utils/use-view-tracking';

import './style.scss';

export default function PoiCampaignSection(): JSX.Element {
  const { poi_id: poiId = '' } = useParams<{ poi_id: string }>();

  const ref = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_page_module: ModuleType.activity_banner,
        current_position: ClickPosition.activity_banner,
        page_id: poiId,
      });
    }, []),
  });

  return (
    <section ref={ref} id="poi-campaign">
      <CampaignCarousel />
    </section>
  );
}
